import { useStore } from '@/containers'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'

export const PopularSearchWords = ({ className }: { className?: string }) => {
  const { keywords } = useStore()

  if (!keywords?.length) return null

  return (
    <div className={`${className} rounded-xl bg-white p-5 pb-7`}>
      <h3 className='text-2xl font-bold text-[#282828]'>
        Mọi người cũng tìm kiếm
      </h3>
      <div className='mt-5 flex flex-wrap gap-x-2 gap-y-3'>
        {keywords.map(item => (
          <Link
            key={item._id}
            href={`/search?query=${encodeURIComponent(
              getTranslate(item.name)
            )}`}
            className='flex h-9 items-center rounded-full bg-[#F3F5F7] px-4 text-sm text-black-400'
          >
            {getTranslate(item.name)}
          </Link>
        ))}
      </div>
    </div>
  )
}
